import SectionLayout from 'ui/SectionLayout';
import ChatGreeting from './Layout/ChatGreeting';
import styled from '@emotion/styled';
import ChatTextbox from './Layout/ChatTextbox';
import { AIAgentViewProps } from './types';
import ChatMessages from './Layout/ChatMessages';

const AIAgentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 100%;
`;

const AIAgentView = (props: AIAgentViewProps) => {
  const { messages, integrations, loading, onSendMessage, onFeedbackClick } = props;

  const hasMessages = messages.length > 0;

  const isConnected = integrations.some((integration) => integration.isConnected);

  let content: React.ReactNode = (
    <AIAgentWrapper>
      {hasMessages && (
        <ChatMessages loading={loading.api} messages={messages} onFeedbackClick={onFeedbackClick} />
      )}
      {!hasMessages && <ChatGreeting integrations={integrations} />}
      <ChatTextbox onSendMessage={onSendMessage} disabled={!isConnected} />
    </AIAgentWrapper>
  );

  if (loading.integrations) {
    content = null;
  }

  return (
    <SectionLayout title="AI Assistant" addPadding={false} resizeToScreen>
      {content}
    </SectionLayout>
  );
};

export default AIAgentView;
